import * as T from './actionTypes';

const INIT_STATE = {
  tco: null,
  loading: false,
  error: null,
};

const AssetTCO = (state = INIT_STATE, action) => {
  switch (action.type) {
    case T.FETCH_ASSET_TCO:
      return { ...state, loading: true, error: null };
    case T.FETCH_ASSET_TCO_SUCCESS:
      return { ...state, loading: false, tco: action.payload };
    case T.FETCH_ASSET_TCO_FAIL:
      return { ...state, loading: false, error: action.payload };
    case T.CLEAR_ASSET_TCO:
      return INIT_STATE;
    default:
      return state;
  }
};

export default AssetTCO;
